import axios from 'axios';

export default {
    equalizeLengths(id, records) {
        return axios.post('/optimizedpaintlist/equalizeLengths/', {
            optimizedpaintlistId: id,
            records,
        });
    },
    splitRecord(recordId) {
        return axios.post('/optimizedpaintlist/splitRecord/', { recordId });
    },
    combineRecords(recordIds) {
        return axios.post('/optimizedpaintlist/combineRecords/', { recordIds });
    },
    useProfileLengthForRecord(recordId) {
        return axios.post('/optimizedpaintlist/useProfileLengthForRecord/', {
            recordId,
        });
    },
    combineAllAmounts(id) {
        return axios.post('/optimizedpaintlist/combineAllAmounts/', {
            optimizedpaintlistId: id,
        });
    },
    updateSawnForRecord(recordId, sawn) {
        return axios.post('/optimizedpaintlist/updateSawnForRecord/', {
            recordId,
            sawn,
        });
    },
    remove(id) {
        return axios.post('/optimizedpaintlist/remove/', {
            optimizedpaintlistId: id,
        });
    },
    fetchAllBaskets() {
        return axios.post('/optimizedpaintlist/fetchAllBaskets/');
    },
    fetch(id) {
        return axios.post('/optimizedpaintlist/fetch/', {
            optimizedpaintlistId: id,
        });
    },
    updateUrgent(id, urgent) {
        return axios.post('/optimizedpaintlist/updateUrgent', {
            optimizedpaintlistId: id,
            urgent,
        });
    },
    updateType(id, type) {
        return axios.post('/optimizedpaintlist/updateType', {
            optimizedpaintlistId: id,
            type,
        });
    },
    fetchPrevious(optimizedpaintlistId, paintworkorderId) {
        return axios.post('/optimizedpaintlist/fetchPrevious/', {
            optimizedpaintlistId,
            paintworkorderId,
        });
    },
    fetchNext(optimizedpaintlistId, paintworkorderId) {
        return axios.post('/optimizedpaintlist/fetchNext/', {
            optimizedpaintlistId,
            paintworkorderId,
        });
    },
    list(offset, limit) {
        return axios.post('/optimizedpaintlist/list/', { offset, limit });
    },
    insertForColor(colorId, productNr) {
        return axios.post('/optimizedpaintlist/insertForColor/', {
            colorId,
            productNr,
        });
    },
    fetchForBatch(request, optimizedpaintlistId) {
        return axios.post('/optimizedpaintlist/fetchForBatch/', {
            request,
            optimizedpaintlistId,
        });
    },
    updateStatus(optimizedpaintlistId) {
        return axios.post('/optimizedpaintlist/updateStatus/', {
            optimizedpaintlistId,
        });
    },
    fetchToProcess(paintshopId, types = []) {
        return axios.post('/optimizedpaintlist/fetchToProcess/', {
            paintshopId,
            types,
        });
    },
    setBeams(optimizedpaintlistId, beams) {
        return axios.post('/optimizedpaintlist/setBeams', {
            optimizedpaintlistId,
            beams,
        });
    },
    updatePowderUsage(optimizedpaintlistId, powderUsage, apply, employeeId) {
        return axios.post('/optimizedpaintlist/updatePowderUsage', {
            optimizedpaintlistId,
            powderUsage,
            apply: apply ? '1' : '0',
            employeeId,
        });
    },
    updateProductsStatus(optimizedpaintlistId, status, employeeId) {
        return axios.post('/optimizedpaintlist/updateProductsStatus', {
            optimizedpaintlistId,
            status,
            employeeId,
        });
    },
    addRecord(payload) {
        return axios.post('/optimizedpaintlist/addRecord/', payload);
    },
    updateRecord(payload) {
        return axios.post('/optimizedpaintlist/updateRecord/', payload);
    },
    fetchCountWithErrorWithoutPaintworkform(paintshop = null) {
        return axios.post(
            '/optimizedpaintlist/fetchCountWithErrorWithoutPaintworkform/',
            { paintshop }
        );
    },
    fetchCountWithExpressWithoutPaintworkform(paintshop = null) {
        return axios.post(
            '/optimizedpaintlist/fetchCountWithExpressWithoutPaintworkform/',
            { paintshop }
        );
    },
    fetchCountWithPleatingWithoutPaintworkform(paintshop = null) {
        return axios.post(
            '/optimizedpaintlist/fetchCountWithPleatingWithoutPaintworkform/',
            { paintshop }
        );
    },
    removeBasket(basket, optimizedpaintlistId) {
        return axios.post('/optimizedpaintlist/removeBasket/', {
            basket,
            optimizedpaintlistId,
        });
    },
    addBasket(basket, optimizedpaintlistId) {
        return axios.post('/optimizedpaintlist/addBasket/', {
            basket,
            optimizedpaintlistId,
        });
    },
    updateDescription(description, optimizedpaintlistId) {
        return axios.post('/optimizedpaintlist/updateDescription/', {
            description,
            optimizedpaintlistId,
        });
    },
    updateTrackNr(trackNr, optimizedpaintlistId) {
        return axios.post('/optimizedpaintlist/updateTrackNr/', {
            trackNr,
            optimizedpaintlistId,
        });
    },
    updateSawn(optimizedpaintlistId) {
        return axios.post('/optimizedpaintlist/updateSawn/', {
            optimizedpaintlistId,
        });
    },
    validateExistence(optimizedpaintlistId) {
        return axios.post('/optimizedpaintlist/validateExistence/', {
            optimizedpaintlistId,
        });
    },
    setPaintshop(optimizedpaintlistId, paintshopId) {
        return axios.post('/optimizedpaintlist/setPaintshop/', {
            optimizedpaintlistId,
            paintshopId,
        });
    },
    removeRecord(recordId) {
        return axios.post('/optimizedpaintlist/removeRecord', { recordId });
    },
    fetchPaintScreenData(optimizedpaintlistId) {
        return axios.get(
            `[API]/optimized-paint-lists/${optimizedpaintlistId}/paint-screen-data`
        );
    },
    postPaintScreenData(
        optimizedpaintlistId,
        colorSort,
        beams,
        usedPowderInGrams,
        sparePowderTakenInGrams,
        status,
        employeeId
    ) {
        return axios.post(
            `[API]/optimized-paint-lists/${optimizedpaintlistId}/paint-screen-data`,
            {
                colorSort,
                beams,
                usedPowderInGrams,
                sparePowderTakenInGrams,
                status,
                employeeId,
            }
        );
    },
};
